export const KEY_UP = 38;
export const KEY_DOWN = 40;
export const SPACE = 32;
